import React, { useEffect, useState } from 'react';

import ModalFooter from 'CommonComponents/ModalFooter';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function EditInputReachCategoryModal(props) {
    const [name, setName] = useState(props.name);

    useEffect(() => {
        if (!name && props.name) {
            setName(props.name);
        }
    }, [props.name]);

    const internalCloseHandler = () => {
        props.closeHandler();
        setName('');
    };

    const internalSuccessHandler = () => {
        props.successHandler(name);
        setName('');
    };

    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title="Edit Category name" close={props.closeHandler}></ModalHeader>
                    <div className="tw-rounded-b">
                        {props.name != '' && (
                            <div className="modal__form-container">
                                <div className="tw-grid tw-grid-cols-1">
                                    <div className="tw-flex tw-flex-col tw-space-y-1.5">
                                        <label className="text-input__label">Category name</label>
                                        <input
                                            className={'tw-border-0 text-input'}
                                            type={'text'}
                                            value={name}
                                            placeholder={'Enter category name'}
                                            onChange={(e) => {
                                                setName(e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>

                                <ModalFooter
                                    cancelButtonText={$t('Cancel')}
                                    primaryButtonText={$t('OK')}
                                    onCancel={internalCloseHandler}
                                    handleSubmit={internalSuccessHandler}
                                ></ModalFooter>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
